import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReplaySubject, Subject } from 'rxjs';

import { SideSectionService } from '../services/side-section.service';
import { SideContainerType } from '../social-menu/enums/SideContainerType';

import ModalActionType from './ModalActionType';

export interface ModalSocialEventData {
  title: string;
  message?: string;
  messageBold: string;
  cancelButtonTitle?: string;
  confirmButtonTitle?: string;
  hideModalButtonTitle?: string;
  showModalButtonTitle?: string;
  showContent: boolean;
  warningMessage?: string;
  isPresenter: boolean;
}

@Component({
  selector: 'app-modal-social-event',
  templateUrl: './modal-social-event.component.html',
  styleUrls: ['./modal-social-event.component.scss'],
  standalone: false,
})
export class ModalSocialEventComponent implements OnDestroy {
  public eventSubject = new Subject<ModalActionType>();
  public title = '';
  public message = '';
  public messageBold = '';
  public cancelButtonTitle?: string;
  public confirmButtonTitle?: string;
  public hideModalButtonTitle?: string;
  public showModalButtonTitle?: string;
  public showContent = true;
  public warningMessage = '';
  public isPresenter = false;

  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(
    private store: Store,
    public sideSectionService: SideSectionService,
  ) {}

  public onCancel(): void {
    this.eventSubject.next(ModalActionType.CANCEL);
  }

  public onConfirm(): void {
    this.eventSubject.next(ModalActionType.PRIMARY);
  }

  public onHideModal(): void {
    this.showContent = false;
  }

  public onShowModal(): void {
    this.showContent = true;
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public get sideContainerType(): typeof SideContainerType {
    return SideContainerType;
  }
}
